import React, { useContext, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  makeStyles, Typography, Button,
} from '@material-ui/core';

// import PropTypes from 'prop-types';
import {
  UnauthenticatedTemplate, AuthenticatedTemplate, useMsal, useAccount,
} from '@azure/msal-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { loginRequest } from '../../config/authConfig';
import AppContext from '../../state/AppContext';
import { fetchStaticToken, swallowMsalErrors } from '../../helpers/authentication';
import api from '../../config/api';
import { isValidatingCustomerState } from '../../state/apiRequestStatus';
import { jwtTokenState, validatedCustomerState } from '../../state/apiData';

const useStyles = makeStyles(() => ({
  btnLogin: {
    padding: '0 5px',
    margin: '0 30px',
    color: '#ffffff',
    fontSize: '14px',
  },
  emailWrapper: {
    flex: '1 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.6,
  },
}));

const HeaderLogin = () => {
  const intl = useIntl();
  const {
    setCustomerNeedsSignup,
    setCustomerNotValid,
  } = useContext(AppContext);

  const setValidatedCustomer = useSetRecoilState(validatedCustomerState);
  const [isValidatingCustomer, setIsValidatingCustomer] = useRecoilState(isValidatingCustomerState);
  const [jwtToken, setJwtToken] = useRecoilState(jwtTokenState);

  const classes = useStyles();
  const {
    instance,
    accounts,
    inProgress,
  } = useMsal();

  const account = useAccount(accounts[0] || {
    idTokenClaims: {
      emails: [],
    },
  });

  useEffect(() => {
    if (account) {
      instance.acquireTokenSilent({
        scopes: ['openid'],
        account,
      })
        .then((response) => {
          if (response) {
            setJwtToken(response.idToken);
          }
        })
        .catch(swallowMsalErrors);
    }
  }, [account, instance]);

  useEffect(async () => {
    setValidatedCustomer(null);
    setCustomerNeedsSignup(false);
    setCustomerNotValid(false);

    if (account) {
      if (window && window.gtag) {
        window.gtag('event', 'login', {
          method: 'Email',
        });
      }
      setIsValidatingCustomer(true);
      const responseValidation = await fetchStaticToken({
        url: api.customerValidation,
        method: 'POST',
        body: {
          email: account.idTokenClaims.emails[0],
          jwt: jwtToken,
        },
      });

      const validation = await responseValidation.json();
      if (responseValidation.status === 200) {
        setValidatedCustomer(validation);
        return setIsValidatingCustomer(false);
      }

      if (responseValidation.status === 400) {
        if (validation.code === 'EmailNotExistsError') {
          setCustomerNeedsSignup(true);
        }
      }

      setCustomerNotValid(true);
      return setIsValidatingCustomer(false);
    }
    return null;
  }, [jwtToken]);

  return (
    <>
      <UnauthenticatedTemplate>
        <Button
          className={classes.btnLogin}
          onClick={() => instance.loginPopup(loginRequest(intl.locale)).catch(swallowMsalErrors)}
          disabled={inProgress === 'login' || isValidatingCustomer}
        >
          {inProgress === 'login' || isValidatingCustomer
            ? <FormattedMessage id="LoginHeader.loggingIn" />
            : <FormattedMessage id="LoginHeader.login" />}
        </Button>
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        {account
          && (
            <Typography component="span" className={classes.emailWrapper}>
              {account.idTokenClaims.emails[0] || ''}
            </Typography>
          )}
        <Typography component="span">
          <Button
            className={classes.btnLogin}
            onClick={() => instance.logout()}
          >
            <FormattedMessage id="LoginHeader.logout" />
          </Button>
        </Typography>
      </AuthenticatedTemplate>
    </>
  );
};
HeaderLogin.propTypes = {};

export default HeaderLogin;
